<template>
  <div class="teaching-arrange-setting-period">
    <DataGrid size="mini"
              border="none"
              :data="periods">
      <DataGridColumn title="时段名称"
                      field="name"
                      width="20%"
                      align="center">
      </DataGridColumn>
      <DataGridColumn title="时段说明"
                      align="center">
        <template #default="{row}">
          <el-input v-model="row.description"
                    size="mini"
                    type="text"
                    maxlength="100"
                    placeholder="请填写时段说明内容"
                    :disabled="disabled"></el-input>
        </template>
      </DataGridColumn>
      <template #empty>
        <span>没有可设置的时段</span>
      </template>
    </DataGrid>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
export default {
  name: 'TeachingArrangeSettingPeriod',
  components: {
    DataGrid,
    DataGridColumn
  },
  props: {
    periods: Array,
    disabled: Boolean
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        const periods = this.periods
        if (periods && periods.length) {
          let valid = periods.every(period => {
            if (!period.description) {
              reject(new Error(`${period.name}时段说明不能为空`))
              return
            }
            return true
          })
          if (!valid) {
            return
          }
          resolve(periods.map(period => {
            return {
              type: period.code,
              description: period.description
            }
          }))
        } else {
          reject(new Error('没有可设置的时段'))
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting-period {
    .vxe-table {
      .vxe-table--header-wrapper {
        margin-bottom: 5px;
        .vxe-table--header {
          .vxe-header--row {
            background-color: #f3f4f5;
          }
        }
      }
      .vxe-table--body-wrapper {
        .vxe-table--body {
          .vxe-body--row {
            .vxe-body--column {
              .vxe-cell {
                .el-input {
                  .el-input__inner {
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
      .vxe-table--empty-placeholder {
        margin-top: 1px;
        background-color: #fcfcfc;
      }
    }
  }
</style>
